import { Box, TextField, InputAdornment, Divider } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import "./styles.css";

const OnboardInputField = ({ studentName, onStudentNameChange }) => {
  const handleInputChange = (event) => {
    const value = event.target.value;
    const regex = /^[a-zA-Z\s]*$/;
    if (regex.test(value)) {
      onStudentNameChange(value);
    }
  };
  return (
    <Box className="onboard-box">
      <TextField
        variant="outlined"
        placeholder="Enter your name"
        value={studentName}
        onChange={handleInputChange}
        className="onboard-textfield"
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <PersonIcon />
              <Divider
                orientation="vertical"
                flexItem
                className="onboard-divider"
              />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default OnboardInputField;
